/* ============================================================
   v212 — psi-delivery-eta.js
   Calcola la finestra di consegna stimata e la scrive nei contenitori
   [data-psi-eta] messi da snippets/psi-delivery-eta.liquid.

   PERCHE' NEL BROWSER E NON IN LIQUID
   Shopify mette le pagine in cache. Una data calcolata sul server resterebbe
   congelata al momento in cui la pagina e' entrata in cache: alle 10:30
   direbbe ancora "parte oggi" a chi e' arrivato dopo il cutoff.

   IL FUSO E' FORZATO A Europe/Rome
   Il cutoff e' un fatto del magazzino di Teverola, non del visitatore. Chi guarda
   dalla Germania o col telefono su un altro fuso deve vedere lo stesso orario.

   I PARAMETRI NON SONO QUI
   Stanno negli attributi data- dello snippet, che e' l'unica fonte.
   ============================================================ */
(function () {
  'use strict';

  /* Lo snippet viene reso due volte su una scheda prodotto (scheda + cassetto
     carrello), quindi questo file compare due volte nell'HTML. */
  if (window.__psiEtaAttivo) return;
  window.__psiEtaAttivo = true;

  var GIORNI = ['domenica', 'luned\u00EC', 'marted\u00EC', 'mercoled\u00EC', 'gioved\u00EC', 'venerd\u00EC', 'sabato'];
  var MESI = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
              'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];

  function adessoARoma() {
    var parti = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Rome',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var v = {};
    parti.forEach(function (p) { if (p.type !== 'literal') v[p.type] = p.value; });
    return {
      anno: +v.year, mese: +v.month, giorno: +v.day,
      ora: +v.hour === 24 ? 0 : +v.hour, minuto: +v.minute
    };
  }

  /* Date UTC a mezzanotte: contenitori di calendario. UTC evita che un cambio di
     ora legale sposti un giorno mentre si conta. */
  function data(anno, mese, giorno) { return new Date(Date.UTC(anno, mese - 1, giorno)); }
  function iso(d) {
    return d.getUTCFullYear() + '-' +
           String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
           String(d.getUTCDate()).padStart(2, '0');
  }
  function distanza(a, b) { return Math.round((b.getTime() - a.getTime()) / 86400000); }

  function lavorativo(d, festivi) {
    var g = d.getUTCDay();
    if (g === 0 || g === 6) return false;
    return festivi.indexOf(iso(d)) === -1;
  }
  function prossimoLavorativo(d, festivi) {
    var x = new Date(d.getTime());
    do { x.setUTCDate(x.getUTCDate() + 1); } while (!lavorativo(x, festivi));
    return x;
  }
  function aggiungiLavorativi(d, n, festivi) {
    var x = new Date(d.getTime());
    while (n > 0) { x = prossimoLavorativo(x, festivi); n--; }
    return x;
  }

  /* ------------------------------------------------------------
     COME SI SCRIVONO LE DATE

     formato "completo" (attuale): nome del giorno per intero piu' il numero, e
     per la partenza le parole di tutti i giorni al posto del nome quando si puo'.
         "Partenza domani, 12 agosto · Consegna stimata tra venerdi' 14 e luned\u00EC 17 agosto"
     "oggi" e "domani" si capiscono a colpo d'occhio, il numero toglie ogni dubbio
     su quale settimana.

     formato "nomi": solo i nomi dei giorni, senza numeri. Piu' scorrevole ma su
     una consegna che cade nella settimana dopo obbliga il cliente a fare un conto.

     IL MESE si scrive solo sull'ultima data. Se le due cadono in mesi diversi va
     su entrambe, altrimenti si legge "tra marted\u00EC 30 e gioved\u00EC 2 settembre" e sembra
     che anche il 30 sia di settembre.
     ------------------------------------------------------------ */
  function conNumero(d, conMese) {
    return GIORNI[d.getUTCDay()] + ' ' + d.getUTCDate() +
           (conMese ? ' ' + MESI[d.getUTCMonth()] : '');
  }

  /* La partenza usa "oggi" e "domani" quando la data e' quella: sono le parole
     con cui si ragiona davvero. Da due giorni in poi torna il nome del giorno,
     perche' "dopodomani" e' piu' lento da leggere di "venerdi'". */
  function formattaPartenza(d, oggi, formato) {
    var giorno = d.getUTCDate() + ' ' + MESI[d.getUTCMonth()];
    var dist = distanza(oggi, d);
    if (formato === 'nomi') {
      if (dist === 0) return 'oggi';
      if (dist === 1) return 'domani';
      return GIORNI[d.getUTCDay()];
    }
    if (dist === 0) return 'oggi, ' + giorno;
    if (dist === 1) return 'domani, ' + giorno;
    return conNumero(d, true);
  }

  function formattaConsegna(d, formato, conMese) {
    if (formato === 'nomi') return GIORNI[d.getUTCDay()];
    return conNumero(d, conMese);
  }

  function calcola(cfg) {
    var ora = adessoARoma();
    var oggi = data(ora.anno, ora.mese, ora.giorno);

    var parteOggi = lavorativo(oggi, cfg.festivi) && ora.ora < cfg.cutoff;
    var spedizione = parteOggi ? oggi : prossimoLavorativo(oggi, cfg.festivi);

    var scarto = cfg.inclusivo ? 1 : 0;
    var da = aggiungiLavorativi(spedizione, cfg.transitMin - scarto, cfg.festivi);
    var a  = aggiungiLavorativi(spedizione, cfg.transitMax - scarto, cfg.festivi);

    var consegna;
    if (iso(da) === iso(a)) {
      /* min e max coincidono: "tra X e X" non si dice */
      consegna = 'Consegna stimata <b>' + formattaConsegna(a, cfg.formato, true) + '</b>';
    } else {
      var mesiDiversi = da.getUTCMonth() !== a.getUTCMonth();
      consegna = 'Consegna stimata tra <b>' + formattaConsegna(da, cfg.formato, mesiDiversi) +
                 '</b> e <b>' + formattaConsegna(a, cfg.formato, true) + '</b>';
    }

    var partenza = 'Partenza <b>' + formattaPartenza(spedizione, oggi, cfg.formato) + '</b>';
    if (parteOggi) partenza += ' se ordini entro le ' + cfg.cutoff + ':00';

    return { testo: partenza + ' \u00B7 ' + consegna };
  }

  function leggiConfig(el) {
    return {
      cutoff: parseInt(el.dataset.cutoff, 10) || 10,
      transitMin: parseInt(el.dataset.transitMin, 10) || 2,
      transitMax: parseInt(el.dataset.transitMax, 10) || 3,
      inclusivo: el.dataset.inclusivo === 'true',
      formato: el.dataset.formato === 'nomi' ? 'nomi' : 'completo',
      festivi: (el.dataset.festivi || '').split(',').map(function (s) { return s.trim(); })
    };
  }

  function disegna() {
    document.querySelectorAll('[data-psi-eta]').forEach(function (el) {
      var cfg = leggiConfig(el);
      var r;
      /* Se il calcolo va storto il blocco resta nascosto: meglio nessuna data che
         una data sbagliata. La scheda continua a rimandare a /pages/spedizioni. */
      try { r = calcola(cfg); } catch (e) { return; }
      var t = el.querySelector('[data-psi-eta-text]');
      if (t) t.innerHTML = r.testo;
      el.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disegna);
  } else {
    disegna();
  }

  /* Il cassetto carrello viene ricostruito dal tema quando cambia il carrello:
     il blocco torna nascosto e va ridisegnato. */
  var drawer = document.getElementById('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawer.querySelector('[data-psi-eta][hidden]')) disegna();
    }).observe(drawer, { childList: true, subtree: true });
  }
}());
